
import React, { useRef, useState } from "react"
import { Textarea } from "../../../../components/formComponents";
import t from "../../../../service/translate.service";
import { Modal } from "antd";

const DescriptionModal = (props) => {

  const inputRefs = useRef({})
  const [submitted, setSubmitted] = useState(false)
  const [errorsList, setErrorsList] = useState([])
  const [errorListVoice, setErrorListVoice] = useState(false)

  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'description') {
        const val = item?.value
        const error = !val && t.CONSULTATIONS_DESCRIPTION
        if (error) {
          errors.push(
            <button
              key={1}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {error}
            </button>
          )
        }
      }
    }
    return errors
  }

  return (
    <Modal
      open={true}
      onCancel={() => {
        props.closeAppointment('description');
      }}
      footer={[
        <button
          style={{
            marginRight: '10px'
          }}
          className="button secondary small"
          key="cancel"
          onClick={() => {
            props.closeAppointment('description');
          }}
          aria-label={t.CLOSE_DESCRIPTION}
        >
          {t.CONSULTATIONS_CANCEL}
        </button>,
        <button
          className="button primary small"
          key="ok"
          onClick={() => {
            props.setSubmitted(true);
            setSubmitted(false)
            setTimeout(() => {
              setErrorListVoice(true)
              setErrorsList(generateErrorList())
              setSubmitted(true)
            }, 100)
            if (props.description) {
              props.onSubmit();
              props.setShowDescriptionModal(false);           
            }
          }}
          aria-label={t.SUBMIT_DESCRIPTION}
        >
          {t.CONSULTATIONS_OK}
        </button>
      ]}
      aria-labelledby="descriptionModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className={`${props.count === 0 ? 'error-message' : ''}`} id="descriptionModalMessage">
          {props.bookingTimeLeftMessage}
        </p>
        {submitted && (
          <div
            style={{
              backgroundColor: '#fff2f0',
              border: '1px solid #ffccc7',
              padding: '8px 12px',
              borderRadius: '8px'
              }}
            >
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          </div>
        )}
        <Textarea 
          ref={(el) => (inputRefs.current['description'] = el)}
          placeholder={t.CONSULTATIONS_DESCRIPTION_PLACEHOLDER}
          value={props.description}
          label={t.CONSULTATIONS_DESCRIPTION}
          required={true}
          maxLength={300}
          onChange={(e) => {
            setErrorListVoice(false)
            props.setDescription(e.target.value)
          }}
          aria-labelledby="descriptionInputLabel"
        />
        <div 
          style={{
            display: 'flex',
            justifyContent: `${!props.description && props.submitted ? 'space-between' : 'end'}`
          }}
        >
          {!props.description && props.submitted && (
            <div className="error-message" role="alert" aria-live="assertive">
              {t.CONSULTATIONS_DESCRIPTION}
            </div>
          )}
          <p
            style={{
              marginTop: '11px',
              marginBottom: 0
            }}
            className="modal-p"
          >
            {`${props.description.length}/300`}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DescriptionModal;
